import { Component, OnInit, Input, OnDestroy, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { AppService } from 'src/app/app.service';
import { TabitPayService } from 'src/app/tabit-pay/tabit-pay.service';
import * as _ from 'lodash';

@Component({
    selector: 'app-tabitpay-ticket-checks',
    templateUrl: './tabitpay-ticket-checks.component.html',
    styleUrls: ['./tabitpay-ticket-checks.component.scss'],
    standalone: false
})
export class TabitpayTicketChecksComponent implements OnInit, OnDestroy  {
	@Input() $storage;
	@Output() onCheckSelect = new EventEmitter<any>();
	isUS: boolean;
	args: any = {}

	private orderSubscription: Subscription = null;
	private checkSubscription: Subscription = null;

	constructor(
		public appService: AppService,
		public tabitPayService: TabitPayService,
	) {
		this.isUS = this.appService.region == 'US';
	}

	ngOnInit() {
		this.checkOrder();
		this.orderSubscription = this.tabitPayService.orderChanged$.subscribe(() => {
			this.checkOrder();
		});
		this.checkSubscription = this.tabitPayService.checkChanged$.subscribe(() => {
			this.checkOrder();
		});
	}

	ngOnDestroy() {
		this.orderSubscription.unsubscribe();
		this.checkSubscription.unsubscribe();
	}

	checkOrder() {
		if (this.isUS) {
			let totalTips = (_.get(this.$storage.order.totals, 'totalTips', 0) - _.get(this.$storage.order.totals, 'totalServiceCharge', 0));
			this.args.totalTips = totalTips / 100;
		}
	}

	_onCheckSelect(check) {
		this.onCheckSelect.emit(check);
	}

}
